import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-loading',
  templateUrl: './item-loading.component.html',
  styleUrls: ['./item-loading.component.scss'],
})
export class ItemLoadingComponent implements OnInit {
  @Input() isForMyBookingsTab = false

  constructor() { }

  ngOnInit() {}

}
